/* src/modules/locations/cards/AddLocationCard/actions.js */

import {
  LOCATION_NAME_CHANGED,
  LOCATION_ADDRESS_CHANGED,
  LOCATION_CITY_CHANGED,
  LOCATION_TYPE_CHANGED,
  LOCATION_LONGITUDE_CHANGED,
  LOCATION_LATITUDE_CHANGED,
  CLEAR_LOCATION_FIELDS,
} from './action_types';

export const locationNameChanged = payload => ({
  type: LOCATION_NAME_CHANGED,
  payload,
});

export const locationAddressChanged = payload => ({
  type: LOCATION_ADDRESS_CHANGED,
  payload,
});

export const locationCityChanged = payload => ({
  type: LOCATION_CITY_CHANGED,
  payload,
});

export const locationTypeChanged = payload => ({
  type: LOCATION_TYPE_CHANGED,
  payload,
});

export const locationLongitudeChanged = payload => ({
  type: LOCATION_LONGITUDE_CHANGED,
  payload,
});

export const locationLatitudeChanged = payload => ({
  type: LOCATION_LATITUDE_CHANGED,
  payload,
});

export const clearLocationFields = () => ({
  type: CLEAR_LOCATION_FIELDS,
});



// WEBPACK FOOTER //
// ./src/modules/locations/cards/AddLocationCard/actions.js